module.exports = __webpack_public_path__ + "img/FUNderConstruction.a7b57c34.png";